import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function Registration() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container">
      <PageCarousel />

      <section className="section-padding">
        <div className="container">

          {/* Title */}
          <div className="text-center mb-5">
            <h1 className="fw-bold">Registration</h1>
          </div>

          {/* Main Card */}
          <div className="card shadow-lg border-0 p-4">

            {/* Description */}
            <p style={{ lineHeight: '1.8', fontSize: '16px' }}>
              Registration for NCVPRIPG 2026 conference is mandatory for all participants. For inclusion of an accepted paper in the conference proceedings, at least one author must register with the full registration fee on or before the early-bird registration deadline. One full registration is valid for one paper only. For presentation and publication of each additional accepted paper by the same registered author an additional 50% of the full registration fee per paper will be charged.
            </p>

            {/* Important Notes */}
            <div className="mt-4 p-4 rounded" style={{ background: '#f8f9fa' }}>
              <h5 className="fw-bold mb-3">Important Notes</h5>
              <ul style={{ lineHeight: '2' }}>
                <li>At least one author must register per paper on or before the early-bird registration deadline.</li>
                <li>Registration includes access to all technical sessions, sessions on challenges and tutorials.</li>
                <li>Participants with full registration will receive the conference kit, lunch on all conference days, and an invitation to the conference dinner and free access to all technical sessions, tutorials, and challenges.</li>
                <li>Participation only in challenges, student research symposium, or tutorials requires separate registration under the respective category. This registration includes participation in all sessions scheduled on the respective day.</li>
                <li>The conference will follow a no-show policy and paper not presented in the conference will not be included in the conference proceedings.</li>
              </ul>
            </div>

            {/* Fee Section */}
            <div className="mt-5">
              <h4 className="fw-bold mb-3">Full Registration (Including GST)</h4>
              <ul style={{ lineHeight: '2' }}>
                <li>Early Bird Registration : June 23 – July 08, 2026</li>
                <li>Late Registration: July 09 – July 22, 2026</li>
              </ul>
              <div className="table-responsive">
                <table className="table table-hover align-middle text-center">
                  <thead style={{ background: '#70b60a', color: '#fff' }}>
                    <tr>
                      <th>Category</th>
                      <th>Early Bird (INR)</th>
                      <th>Late (INR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="table-light">
                      <td colSpan="3"><strong>IUPRAI Members</strong></td>
                    </tr>
                    <tr>
                      <td>Authors</td>
                      <td>9500</td>
                      <td>10500</td>
                    </tr>
                    <tr>
                      <td>Non-authors</td>
                      <td>6000</td>
                      <td>6600</td>
                    </tr>
                    <tr>
                      <td>Authors (Industry)</td>
                      <td>12500</td>
                      <td>13800</td>
                    </tr>

                    <tr className="table-light">
                      <td colSpan="3"><strong>Non IUPRAI Members</strong></td>
                    </tr>
                    <tr>
                      <td>Authors</td>
                      <td>10500</td>
                      <td>11600</td>
                    </tr>
                    <tr>
                      <td>Non-authors</td>
                      <td>6500</td>
                      <td>7200</td>
                    </tr>
                    <tr>
                      <td>Authors (Industry)</td>
                      <td>12500</td>
                      <td>13800</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Tutorials */}
            <div className="mt-5">
              <h4 className="fw-bold mb-3">Tutorials (Day 1)</h4>
              <ul style={{ lineHeight: '2' }}>
                <li>Registration for Tutorials Attendees: June 20 - July 22, 2026</li>
              </ul>
              <div className="table-responsive">
                <table className="table table-bordered text-center">
                  <thead className="table-light">
                    <tr>
                      <th>Category</th>
                      <th>Fee (INR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Faculty / Industry / R&D</td>
                      <td>3500</td>
                    </tr>
                    <tr>
                      <td>Students</td>
                      <td>2500</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Challenges */}
            <div className="mt-5">
              <h4 className="fw-bold mb-3">Challenges / Symposium (Day 3)</h4>
              <ul style={{ lineHeight: '2' }}>
                <li>Registration for Challenge Attendees: June 20 – July 15, 2026</li>
              </ul>
              <div className="table-responsive">
                <table className="table table-bordered text-center">
                  <tbody>
                    <tr>
                      <td>Participants</td>
                      <td><strong>4500 INR</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Highlight Box */}
            <div className="mt-4 p-4 text-center rounded"
              style={{
                background: 'linear-gradient(135deg, #70b60a, #4a8c05)',
                color: '#fff'
              }}>
              <h5 className="mb-1">* To avail the Early Bird registration fee, please complete your registration by July 08, 2026.</h5>
            </div>

          </div>

          {/* Registration Process */}
          <div
            className="mb-5 mt-5 p-0 overflow-hidden rounded-4 shadow"
            style={{ border: "1px solid #e8e8e8" }}
          >
            {/* Header */}
            <div
              className="text-center text-white p-4"
              style={{
                background: "linear-gradient(135deg, #70b60a, #4a8c05)"
              }}
            >
              <h2 className="fw-bold mb-2 text-white">
                NCVPRIPG 2026 Registration Process
              </h2>
              <p className="mb-0 text-white">
                Complete the following steps to finalize your conference registration.
              </p>
            </div>

            <div className="p-4 p-md-5 bg-white">

              {/* Note */}
              <div
                className="alert border-0 mb-4"
                style={{
                  background: "#fff8e6",
                  borderLeft: "5px solid #ffc107"
                }}
              >
                <strong>📢 Important:</strong> Registration will be considered complete
                only after successful payment and submission of the registration form.
              </div>

              {/* Step 1 */}
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="rounded-circle text-white d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "50px",
                        height: "50px",
                        background: "#70b60a",
                        fontWeight: "bold",
                        fontSize: "20px"
                      }}
                    >
                      1
                    </div>
                    <div>
                      <h4 className="fw-bold mb-0">Complete the Payment</h4>
                      <small className="text-muted">
                        Choose the appropriate payment category
                      </small>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="border rounded-3 p-3 h-100">
                        <h6 className="fw-bold text-success">
                          Full Registration (Author / Non-Author)
                        </h6>

                        <a
                          href="https://payments.lnmiit.ac.in/participant/payment/ncvpripg-2026-payment-thsuz0"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-success mt-2"
                        >
                          Pay Registration Fee →
                        </a>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="border rounded-3 p-3 h-100">
                        <h6 className="fw-bold text-primary">
                          Tutorial / Challenge / Student Research Symposium
                        </h6>

                        <a
                          href="https://payments.lnmiit.ac.in/participant/payment/ncvpripg-tutorial-th136s"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary mt-2"
                        >
                          Pay Participation Fee →
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Arrow */}
              <div className="text-center mb-4">
                <div style={{ fontSize: "35px", color: "#70b60a" }}>
                  ⬇
                </div>
              </div>

              {/* Step 2 */}
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="rounded-circle text-white d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "50px",
                        height: "50px",
                        background: "#0d6efd",
                        fontWeight: "bold",
                        fontSize: "20px"
                      }}
                    >
                      2
                    </div>

                    <div>
                      <h4 className="fw-bold mb-0">
                        Submit Registration Form
                      </h4>
                      <small className="text-muted">
                        Complete your registration after payment
                      </small>
                    </div>
                  </div>

                  <div
                    className="text-center p-4 rounded-3"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa, #eef5ff)"
                    }}
                  >
                    <p className="mb-3">
                      After successful payment, please fill out the Google Form and
                      upload the required details.
                    </p>

                    <a
                      href="https://forms.gle/kFcwwrYRo7w7fUa36"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-lg btn-primary px-4"
                    >
                      Complete Registration Form →
                    </a>
                  </div>
                </div>
              </div>

              {/* Success Message */}
              <div
                className="mt-4 text-center p-3 rounded-3"
                style={{
                  background: "#e8f8e8",
                  border: "1px solid #bde5bd"
                }}
              >
                <strong>✅ Registration Completed</strong>
                <br />
                Your registration will be processed after successful payment and form
                submission.
              </div>
            </div>
          </div>

          {/* Dedicated Hostel Accommodation Section */}
          <div
            className="mb-5 mt-5 p-0 overflow-hidden rounded-4 shadow"
            style={{ border: "1px solid #e8e8e8" }}
          >
            {/* Section Header */}
            <div
              className="text-center text-white p-4"
              style={{
                background: "linear-gradient(135deg, #0d6efd, #0b5ed7)"
              }}
            >
              <h2 className="fw-bold mb-2 text-white">
                🏠 Hostel Accommodation
              </h2>
              <p className="mb-0 text-white">
                Book your stay at the campus hostels during NCVPRIPG 2026.
              </p>
            </div>

            <div className="p-4 p-md-5 bg-white text-center">
              <p className="text-muted mb-4" style={{ fontSize: '16px', lineHeight: '1.7' }}>
                On-campus hostel accommodation is available for registered participants and delegates. 
                Please complete the payment through the link below to confirm your stay.
              </p>

              <a
                href="https://payments.lnmiit.ac.in/participant/payment/ncvpripg-hostel-accomodation-tiilmj"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg btn-primary px-5 py-3 fw-bold shadow-sm"
                style={{ borderRadius: '30px' }}
              >
                Pay Hostel Accommodation Fee →
              </a>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default Registration;